import { blueGrey, cyan } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

const backgroundContrast = { main: "#081422" };
const backgroundBase = { main: "#020712" };

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      smd: 480,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    backgroundContrast,
    backgroundBase,
    primary: blueGrey,
    secondary: cyan,
    text: {
      primary: blueGrey["100"],
      secondary: cyan["500"],
      tertiary: blueGrey["500"],
    },
    background: {
      paper: backgroundContrast.main,
      default: backgroundBase.main,
    },
    divider: cyan["500"],
  },
  typography: {
    fontFamily: "'Exo 2', sans-serif",
  },
});

export default theme;
